module.exports = __webpack_public_path__ + "img/citrus-slice.46cc5b40.svg";